import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Checkbox, CheckboxProps } from "antd-v5";
import React from "react";

import GripIcon from "ac-components/ac-icons/GripIcon";

const DraggableVisibilityDropdownItem = ({
  id,
  disabled,
  checked,
  title,
  onCheckUnCheck,
  className,
}: {
  id: React.Key;
  disabled: boolean;
  checked: boolean;
  title: React.ReactNode;
  onCheckUnCheck: CheckboxProps["onChange"];
  className?: string;
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    // While dragging, we reduce the opacity of the original item in the list
    // because the DragOverlay is showing the "real" visual clone of the item.
    opacity: isDragging ? 0 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} className={className}>
      <GripIcon
        {...listeners}
        style={{
          fontSize: 18,
          alignSelf: "center",
          cursor: disabled ? "not-allowed" : "grab",
        }}
      />
      <Checkbox
        className="w-100"
        id={id as string}
        onChange={onCheckUnCheck}
        checked={checked}
      >
        {title}
      </Checkbox>
    </div>
  );
};
export default DraggableVisibilityDropdownItem;
